import type React from 'react';
import type {
  Application,
  NextFunction,
  Request,
  RequestHandler,
  Response,
  Router,
} from 'express';

export * from './api/admin';
export * from './api/app';
export * from './api/tracker';
export * from './api/web';

export enum AccessTokenKey {
  admin = 'adminAccessToken',
  crewmember = 'crewmemberAccessToken',
}

export enum AccessTokenType {
  admin = 'ADMIN',
  crewmember = 'CREWMEMBER',
}

export type $AccessTokenPayload = {
  exp?: number;
  id: string;
  tokenId: string;
  tokenType: string;
};

export type $AuthUser = $AccessTokenPayload & {
  exp: number;
  iat: number;
};

export type $Component<P> = React.ReactElement<
React.PropsWithChildren<P>
>;
export type $Children = React.ReactNode;

export type $Request = {
  id: string;
  start?: [number, number];
  user: $AuthUser;
} & Request;

export type $Response = Response;

export type $Router = Router;

export type $Application = Application;

export type $Next = NextFunction;

export type $Middleware = RequestHandler;

export type $GeoLocation = {
  lat: number;
  lng: number;
};
